<template>
  <div class="card" v-loading.fullscreen.lock="loader">
    <div class="section-heading" align="center">CREATE NEW CAMPUS</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
    <el-row>
        <el-col :span="24">
        <el-form-item label="Campus Name" prop="roleName">
            <el-input v-model="form.roleName" placeholder="Enter Campus Name"></el-input>
        </el-form-item>
        </el-col>
    </el-row>
    <br>
    <div align="right">
        <el-button class="btn-theme" @click="addCampus('form')">Create Campus</el-button>
    </div>
    </el-form>
    <br>
    <br>
    <br>
    <div v-if="roles" class="section-heading" align="center">CURRENT CAMPUSES</div>
      <el-table
      :data="roles"
      stripe
      height="400"
      style="width: 100%;">
      <el-table-column
        type="index"
        label="No."
        min-width="40"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="role"
        align="center"
        label="Campus Name"
        min-width="150">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CreateUser',
  data () {
    return {
      roles: [],
      loader: false,
      form: {
        roleName: ''
      },
      rules: {
        roleName: [
          { required: true, message: 'Enter Campus Name', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      getRole: 'Survey/getRole',
      getSurveyRoles: 'Survey/getSurveyRoles'
    })
  },
  mounted () {
    this.loader = true
    this.fetchSurveyRoles()
  },
  methods: {
    ...mapActions({
      createRole: 'Survey/createRole',
      fetchSurveyRoles: 'Survey/fetchSurveyRoles'
    }),
    addCampus (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loader = true
          this.createRole({
            role: this.form.roleName
          })
          this.dialogRole = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  watch: {
    getRole (value) {
      if (value === 'Error') {
        this.$message.error('Try Again....')
      } else if (value.success === true) {
        this.$message.success(value.message)
        this.$refs['form'].resetFields()
      } else {
        this.$message.error(value.message)
      }
      this.fetchSurveyRoles()
      this.loader = false
    },
    getSurveyRoles (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success) {
        let arrTemp = []
        let arrTemp2 = []
        arrTemp = Object.keys(value.data)
        arrTemp.forEach(ele => {
          let data = {}
          data['role'] = ele
          arrTemp2.push(data)
        })
        this.roles = arrTemp2
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Campus/Campus.vue